import { render, staticRenderFns } from "./SkillMapForm.vue?vue&type=template&id=0585387c&"
import script from "./SkillMapForm.vue?vue&type=script&lang=js&"
export * from "./SkillMapForm.vue?vue&type=script&lang=js&"
import style0 from "./SkillMapForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports